<button 
    class="btn-audio" 
    (click)="skipForwards()"
    [style.background-color]="disabled ? 'grey' : ''">
    <fa-icon [icon]="faRedoAlt"></fa-icon>
</button>